import { createBrowserSupabaseClient } from '@powerful/data';

/**
 * Client Supabase do app, criado uma única vez.
 *
 * Instanciar por chamada abriria uma ligação de auth/realtime a cada render. A criação é
 * preguiçosa para que módulos importados em teste não exijam `VITE_SUPABASE_*` só por serem
 * carregados — quem precisa do client chama esta função.
 */
let client: ReturnType<typeof createBrowserSupabaseClient> | null = null;

export function getSupabaseClient(): ReturnType<typeof createBrowserSupabaseClient> {
  client ??= createBrowserSupabaseClient(import.meta.env);
  return client;
}

/** Uso exclusivo dos testes. */
export function __resetSupabaseClient(): void {
  client = null;
}
